import { Component, Inject, Type, Injector, ElementRef, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

/* 

this.dialog.open(PreviewDialogComponent, {
  data: {
    component: UserPreviewComponent, // your component class
    data: { user: userData }         // optional data for the component
  }
});

*/


export interface PreviewDialogData {
  component: Type<any>;
  data?: any;
}

@Component({
  selector: 'preview-dialog',
  standalone: false,
  template: `
    <div class="dialog-move-header" (mousedown)="startMove($event)">
    </div>
    <mat-dialog-content>
      <ng-container *ngComponentOutlet="data.component; injector: customInjector"></ng-container>
    </mat-dialog-content>
    <mat-dialog-actions class="button-holder" align="end">
      <button class="custom-button" mat-menu-item (click)="onClose()">Zamknij</button>
    </mat-dialog-actions>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [`
    .dialog-move-header {
      cursor: move;
      cursor: move;
    height: 10px;
    padding: 1px 7px;
    background: #f5f5f5;
    border-bottom: 1px solid #ddd;
    button {
      border: none;
      height: 10px;
    }
    }
    .mat-mdc-dialog-surface {
      border-radius: 10px !important; 
    }
  `]
})
export class PreviewDialogComponent {
    customInjector: Injector;
  private isMoving = false;
  private startX = 0;
  private startY = 0;
  private dialogEl: HTMLElement | null = null;
  private origLeft = 0;
  private origTop = 0;

  constructor(
    public dialogRef: MatDialogRef<PreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PreviewDialogData,
    private injector: Injector,
    private elRef: ElementRef,
    private renderer: Renderer2
  ) {
    // Create a custom injector to provide the input
    this.customInjector = Injector.create({
      providers: [
        { provide: 'dialogData', useValue: data.data }
      ],
      parent: this.injector
    });
  }

  ngAfterViewInit() {
    // Find the dialog container
    setTimeout(() => {
      this.dialogEl = this.elRef.nativeElement.closest('.cdk-overlay-pane');
      if (this.dialogEl) {
        this.dialogEl.style.position = 'fixed';
      }
    });
  }

  startMove(event: MouseEvent) {
    event.preventDefault();
    this.isMoving = true;
    this.startX = event.clientX;
    this.startY = event.clientY;
    if (this.dialogEl) {
      const rect = this.dialogEl.getBoundingClientRect();
      this.origLeft = rect.left;
      this.origTop = rect.top;
    }
    this.renderer.listen('window', 'mousemove', this.onMove);
    this.renderer.listen('window', 'mouseup', this.endMove);
  }

  onMove = (event: MouseEvent) => {
    if (!this.isMoving || !this.dialogEl) return;
    const dx = event.clientX - this.startX;
    const dy = event.clientY - this.startY;
    this.dialogEl.style.left = `${this.origLeft + dx}px`;
    this.dialogEl.style.top = `${this.origTop + dy}px`;
    this.dialogEl.style.margin = '0'; // Remove default margin
  };

  endMove = () => {
    this.isMoving = false;
    // Remove listeners if needed
  };

  onClose() {
    this.dialogRef.close();
  }
}



